import React, { useEffect } from "react";
import MasterComponent from "../../../components/Forms";
import { MasterConfigs } from "../../../interfaces/entity";
import { constants } from "../../../constants/common";
import { FormInstance } from "antd";

interface Props {
    projectId: string;
}

const TeamsList: React.FC<Props> = ({
    projectId
}) => {
    const [form, setForm] = React.useState<FormInstance>(null);
    const [counter, setCounter] = React.useState(0);

    useEffect(() => {
        if (form) form.setFieldsValue({ projectId });
    }, [form, projectId, counter])

    const config: MasterConfigs = {
        api: () => '/teams/' + projectId,
        modalTitle: () => 'Teams',
        setInitialForm: () => {
            setCounter(counter + 1)
        },
        isActionTab: true,
        getColumns: () => {
            return [
                {
                    title: 'Name',
                    dataIndex: 'teamMember',
                    key: 'teamMember',
                    render: (text, record) => {
                        return constants.GET_FULL_NAME(record?.teamMember)
                    }
                },
                {
                    title: 'Role',
                    dataIndex: 'role',
                    key: 'role',
                    render: (text, record) => {
                        return text;
                    }
                }
            ]
        },
        getFormColumns: () => [
            {
                label: 'Project',
                name: 'projectId',
                type: 'select',
                span: 8,
                isCombo: true,
                rules: [{ required: true, message: 'Please select a project' }]
            },
            {
                span: 16
            },
            {
                label: 'Team Member',
                type: 'select',
                name: 'teamMember',
                span: 8,
                isCombo: true,
                rules: [{ required: true, message: 'Please select team member' }]
            },
            {
                name: 'role',
                label: 'Access',
                type: 'select',
                span: 8,
                children: [
                    { name: 'Admin', value: 'Admin' },
                    { name: 'Member', value: 'Member' }
                ],
                rules: [{ required: true, message: 'Please select role' }]
            },
        ],
        combo: [
            {
                api: '/projects',
                name: 'projectId',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                api: '/users',
                name: 'teamMember',
                idKey: '_id',
                render: (e) => constants.GET_FULL_NAME(e)
            }
        ],
        actions: [{
            actionType: 'Add',
            name: 'Add Team Member',
        }]
    }

    return (
        <MasterComponent config={config} isModal={true} form={(e) => setForm(e)} />
    );
};

export default TeamsList;